export const getConfig = (token: string) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "content-type": "application/json",
    },
  };
};
